import { useMemo } from 'react';
import type { Issue } from '../types/issue';
import { applyFilters } from '../lib/filter-rows';
import { useData } from '../store/data';
import { useFilters } from '../store/filters';

// Liefert die Issues, die durch den aktuellen Filter-State sichtbar bleiben.
// Memoisiert auf rows + Filter-Felder.
export function useFilteredRows(): Issue[] {
  const rows     = useData(s => s.rows);
  const search   = useFilters(s => s.search);
  const team     = useFilters(s => s.team);
  const assignee = useFilters(s => s.assignee);
  const status   = useFilters(s => s.status);
  const priority = useFilters(s => s.priority);

  return useMemo(
    () => applyFilters(rows, { search, team, assignee, status, priority, spToPtFactor: 1 }),
    [rows, search, team, assignee, status, priority]
  );
}
